import React from 'react';
import '../../styles/style.css';
import reviews from "../../assets/images/reviews.png";
import stars from "../../assets/images/stars.png";
import star from "../../assets/images/star.png";
import view_reviews from "../../assets/images/view_reviews.png";

const Reviews = () => (
  <div className="reviews">
    <div className="container">
      <div className="row">
        <div className="col-md-6 mobile">
          <img src={reviews} alt="Reviews" />
        </div>
        <div className="col-md-6">
          <div className="reviews_content">
            <h1>We are Excellent Rated on Trustpilot!</h1>
            <p className="there_can">There can be no better recommendation than our high percentage of five star reviews.</p>
            <div className="excellent">
              <p><b>Excellent</b> <span><img src={stars} alt="Stars" /></span><b> 4.8</b> out of 5</p>
              <p className="one_star"><b>56 reviews on</b> <span><img src={star} alt="Star" /></span> <b>Trustpilot</b></p>
              <a target="_blank" href={"https://www.trustpilot.com/review/sunboundvillas.com"}>View Reviews <img src={view_reviews} alt="View Reviews" /></a>
            </div>
          </div>
        </div>
        <div className="col-md-6 desktop">
          <img src={reviews} alt="Reviews" />
        </div>
      </div>
    </div>
  </div>
);

export default Reviews;